(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', function (event) {
  if (!event.target.matches('.tab-link')) return;

  event.preventDefault();

  var tab_link_active = document.querySelector('.tabs .active');
  var tab_content_active = document.querySelector('.tab-content.active');
  var tab_content_new = document.getElementById(event.target.getAttribute('href').replace('#', ''));

  tab_link_active.classList.remove('active');
  event.target.parentElement.classList.add('active');
  tab_content_active.classList.remove('active');
  tab_content_new.classList.add('active');
}, false);

  } catch(e) { console.error(e); }
})();
})();
